export default "__VITE_ASSET__BpAaA6BK__"